import React from 'react';
import { useNavigate } from 'react-router-dom';
import { auth } from '../../../firebase';
import HarbourTopBar from '../../components/harbour/HarbourTopBar';
import '../../components/harbour/harbour.css';

/*
 * Harbour portal shell: the canvas page with the shared top bar (brand lockup,
 * the three navigation tabs, the user menu). Every SENCO page renders inside
 * it so navigation behaves the same everywhere.
 */
export const HARBOUR_NAV_ITEMS = [
  { to: '/rms/pupils', label: 'Your pupils', end: true },
  { to: '/rms/pupils/sen-overview', label: 'SEND pathway overview' },
  { to: '/rms/pupils/referral-overview', label: 'Referral pathway overview' },
];

// SENCO accounts sign in with a password, so their menu offers Change
// password (TDI-702).
const SENCO_USER_TYPE = 'RMS School Representative';

export default function HarbourPortalShell({ userName, userEmail, userType, children }) {
  const navigate = useNavigate();
  return (
    <div className="harbour harbour-page">
      {/* 1640 of content inside a 40px gutter (the 1720 desktop frame). The
          padding has to sit outside the 1640 or the three-up card grid, which
          is exactly 3 x 536 + 2 x 16, no longer fits. */}
      <div className="mx-auto w-full max-w-[1720px] px-6 xl:px-10 py-6 flex flex-col gap-6">
        <HarbourTopBar
          navItems={HARBOUR_NAV_ITEMS}
          userName={userName}
          accountEmail={userEmail}
          showChangePassword={userType === SENCO_USER_TYPE}
          onSignOut={async () => {
            try { await auth.signOut(); } catch (_) { /* no-op */ }
            navigate('/rms/school-sign-in?signedout=1');
          }}
        />
        {children}
      </div>
    </div>
  );
}
